export default __webpack_public_path__ + "static/media/xing-logo.85876312.svg";